goog.provide("shadow.js.shim.module$src$svg$artwork$warning_svg$default");
shadow.js.shim.module$src$svg$artwork$warning_svg$default = shadow.js.shim.module$src$svg$artwork$warning_svg.default;
